module.exports = __webpack_public_path__ + "public/adminIcons/last30dayusers.svg?854efb7d";


//////////////////
// WEBPACK FOOTER
// ./public/adminIcons/last30dayusers.svg
// module id = 3336
// module chunks = 8